<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
<style lang="less">
*{
  box-sizing: border-box;
}
body {
  .el-popover {
    background: #222222;
    color: #999;
    border: 1px solid #181818;
    box-sizing: content-box;
  }
}
</style>